import React, { Component } from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';

function RoleRows(props) {
  return (<div>
    {props.roles && props.roles.map((role, index) => {
      return (
        <div key={index} className="role_wrapper clearfix">
          <p className="role">Role</p>
          <p className="role_title">{role.title}<br />
            <span className="role_skills">{role.skills}</span></p>
        </div>)
    })}
  </div>);
}

function YearRow({ year }) {
  return (<div>
    <div className="year-wrapper bottom-bordered clearfix" style={{ display: 'flex', flexDirection: 'row' }}>
      <p className="year_label">YEAR</p>
      <p className="year_value">{year}</p>
    </div>
  </div>);
}

function Title({ link, title }) {
  return (<h2>
    {link && link.length ? (<a href={link} target="_blank">(visit site)</a>) : ""}{" "}
    {title}
  </h2>);
}

const Portfolio = observer(class Portfolio extends Component {

  render() {
    const {
      portfolios = [],
      portfolioSlots = [],
      portfolioKiosks = []
    } = global.store;

    const ProjectRows = [];
    const PortfolioRows = portfolios.map((row, index) => {
      const classname = classNames('portfolio_item', 'clearfix', row.classname);
      if (row.type !== "project") {
        return (
          <div key={index} className={classname}>
            <div>
              <Title title={row.title} link={row.link} />
              <RoleRows roles={row.roles} />
            </div>
            {!row.year ? null : (<YearRow year={row.year} />)}
          </div>
        )
      }
      else {
        ProjectRows.push(<div key={index} className={classname}>
          <div>
            <Title title={row.title} link={row.link} />
            <RoleRows roles={row.roles} />
          </div>
          {!row.year ? null : (<YearRow year={row.year} />)}
        </div>);
      }
    });

    const PortfolioSlotRows = portfolioSlots.map((row, index) => {
      const classname = classNames('portfolio_item', 'clearfix', 'portfoliSlot');
      return (
        <div key={'portfolioSlotRow-' + index} className={classname}>
          <div className={'portfolioSlot-thumbnail'} style={row.thumbnailStyles}>
            <img src={row.image} style={row.imageStyles} className={row.imageClass} />
          </div>
          <div style={{ padding: '0 20px' }}>
            <Title title={row.title} link={row.link} />
            <RoleRows roles={row.roles} />
          </div>
          <div style={{ padding: '0 20px' }}>
            {!row.year ? null : (<YearRow year={row.year} />)}
          </div>
        </div>
      );
    });

    const PortfolioSlotKioskRows = portfolioKiosks.map((row, index) => {
      const classname = classNames('portfolio_item', 'clearfix', 'portfoliSlot', row.classname);
      return (
        <div key={'portfolioSlotRow-' + index} className={classname}>
          <div className={'portfolioSlot-thumbnail'} style={row.thumbnailStyles}>
            <img src={row.image} style={row.imageStyles} className={row.imageClass} />
            <img src={row.logo} style={row.logoStyles} className={"kiosk-logo"} />
          </div>
          <div style={{ padding: '0 20px' }}>
            <Title title={row.title} link={row.link} />
            <RoleRows roles={row.roles} />
          </div>
          <div style={{ padding: '0 20px' }}>
            {!row.year ? null : (<YearRow year={row.year} />)}
          </div>
        </div>
      );
    });


    return (
      <div className="row">
        <div className="col-md-3 col-sm-6 col-xs-6" style={{ padding: "0.5rem", float: "left" }}>
          <h4>SLOT MACHINES ({PortfolioSlotRows.length})</h4>
          <div className="posts">
            {PortfolioSlotRows}
          </div>
        </div>
        <div className="col-md-3 col-sm-6 col-xs-6" style={{ padding: "0.5rem", float: "left" }}>
          <h4>SELF SERVICE KIOSKS ({PortfolioSlotKioskRows.length})</h4>
          <div className="posts">
            {PortfolioSlotKioskRows}
          </div>
        </div>
        <div className="col-md-3 col-sm-6 col-xs-6" style={{ padding: "0.5rem", float: "left" }}>
          <h4>BRANDS ({PortfolioRows.length})</h4>
          <div className="posts">
            {PortfolioRows}
          </div>
        </div>
        <div className="col-md-3 col-sm-6 col-xs-6" style={{ padding: "0.5rem", float: "right" }}>
          <h4>NON PROFIT PROJECTS ({ProjectRows.length})</h4>
          <div className="posts">
            {ProjectRows}
          </div>
        </div>
      </div>
    );

  }
})
export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/Portfolio.js